import { render, staticRenderFns } from "./WidgetCarouselTabs.vue?vue&type=template&id=52e0cf24&scoped=true"
import script from "./WidgetCarouselTabs.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselTabs.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselTabs.vue?vue&type=style&index=0&id=52e0cf24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e0cf24",
  null
  
)

export default component.exports